export default __webpack_public_path__ + "static/media/CAY.86d15759.svg";